import CardImageFlip from "./CardImageFlip";
import totebrown from "../img/tote-r-brown.jpg"
import totewhite from "../img/tote-r-white.jpg"
import totemulticolor from "../img/tote-multi-color.jpeg"
import totepinkgreen from "../img/tote-pink-green.jpeg"
import toteredblack from "../img/tote-red-black.jpeg"
import totetanblue from "../img/tote-tan-blue.jpeg"
import totetan from "../img/tote-tan.jpeg"
import totevoiletblue from "../img/tote-voilet-blue.jpeg"
import totewhiteblue from "../img/tote-white-blue.jpeg"
import herotote from "../img/hero-tote.jpeg"

const MasterCardImgFlipTote = () => {
    return (
        <section class="cards-section lemon-green" id="audit">
            <div class="container">
                <h2 class="section-title">Tote Bags</h2>
                <div class="cards-grid">
                    <CardImageFlip imgFront={herotote} imgBack={totemulticolor} />
                    <CardImageFlip imgFront={totetan} imgBack={totebrown} />
                    <CardImageFlip imgFront={totewhite} imgBack={totewhiteblue} />
                    <CardImageFlip imgFront={totetanblue} imgBack={totepinkgreen} />
                    <CardImageFlip imgFront={toteredblack} imgBack={totevoiletblue} />
                 </div>
            </div>
        </section>
    );
}

export default MasterCardImgFlipTote;